import React, { PureComponent } from 'react';
import { generateCharityImgPath } from 'helpers';
import './Donated.scss';
import { CharityModel } from 'models/Basket';

const BASKET_DONATED_TEXT = 'Thank you for supporting our chosen charity.';
const BASKET_DONATED_TITLE = 'Thank you';

interface OwnProps {
    charity?: CharityModel;
    thankYouImageSize?: string;
}

export class Donated extends PureComponent<OwnProps> {
    render(): JSX.Element {
        const { charity } = this.props;

        return (
            <div className='basket-donation__donated'>
                <h4>{BASKET_DONATED_TITLE}</h4>
                <p className='basket-donation__donated__thanks'>{BASKET_DONATED_TEXT}</p>
                {
                    charity && this.renderCharityThanksImg(charity)
                }
            </div>
        );
    }

    renderCharityThanksImg(charity: CharityModel): JSX.Element {
        return (
            <div className={`basket-donation__donated__thanks${this.props.thankYouImageSize ? '--by-name' : '--by-description'}`}>
                <img
                    src={generateCharityImgPath(charity.id, this.props.thankYouImageSize)}
                    alt='charity logo'
                    onError={e => {
                        e.currentTarget.src = charity?.logoUrl ?? '';
                    }} />
            </div>
        );
    }
}